import React from 'react'
import './index.less'
import { goIndex } from '@/assets/js/utils'
import { wsInit, wsSendMsg, wsColsed } from '@/assets/wsUtils/GetTdDataFun'
let goldDataArr = []; let miniGoldDataArr = []; let silverDataArr = []

class ProductMixedByPlus extends React.Component {
    constructor () {
        super()
        this.state = {
            goldDelayData: '--',
            goldMiniData: '--',
            silverData: '--'
        }
    }

    componentDidMount () {
        const { sublist } = this.props.data
        const isGold = sublist.find(item => item.businessLine === '0916')
        if (isGold) {
            this.connectSocket()
        }
    }

    componentWillUnmount () {
        wsColsed()
    }

    async connectSocket () {
        await wsInit(this.getWsPushMsg)
        await wsSendMsg('["Au(T+D)","mAu(T+D)","Ag(T+D)"]')
    }

    getWsPushMsg = (data) => { // 推送的数据
        if (data.sUserID.trim() === 'Au(T+D)') {
            goldDataArr = this.arr2obj(data.sBody)
            if (goldDataArr.last) {
                this.setState({
                    goldDelayData: goldDataArr.last === '0.00' ? goldDataArr.lastClose : goldDataArr.last
                })
            }
        }
        if (data.sUserID.trim() === 'mAu(T+D)') {
            miniGoldDataArr = this.arr2obj(data.sBody)
            if (miniGoldDataArr.last) {
                this.setState({
                    goldMiniData: miniGoldDataArr.last === '0.00' ? miniGoldDataArr.lastClose : miniGoldDataArr.last
                })
            }
        }
        if (data.sUserID.trim() === 'Ag(T+D)') {
            silverDataArr = this.arr2obj(data.sBody)
            if (silverDataArr.last) {
                this.setState({
                    silverData: silverDataArr.last === '0.00' ? parseInt(silverDataArr.lastClose) : parseInt(silverDataArr.last)
                })
            }
        }
    }

    arr2obj = (arr) => {
        var obj = {}
        if (Array.isArray(arr)) {
            for (var i = 0; i < arr.length; i++) {
                obj[arr[i][0]] = arr[i][1]
            }
        }
        return obj
    }

    // 数据处理超过10个字后显示...
    handleData = (data) => {
        if (data && data.length > 9) {
            return data.slice(0, 9) + '...'
        } else {
            return data
        }
    }

    render () {
        const { buriedPointEvent, data: { position, sublist = [], trackId, style } } = this.props
        const { paddingTop } = style || {}
        const { goldDelayData, goldMiniData, silverData } = this.state
        return (
            <div
                className={'productMixedByPlusContainer'}
                style={{ marginTop: `${paddingTop ? paddingTop / 75 : 0}rem` }}
            >
                {
                    sublist.map((item, index) => {
                        return (
                            <div
                                className={'productMixedItem statistics-dom'}
                                key={index}
                                onClick={() => {
                                    buriedPointEvent({
                                        button_name: `${trackId}-${item.title}`,
                                        button_id: `${item.id}`,
                                        button_order: `${index + 1}`,
                                        area_order: position,
                                        button_area: `${position}-${trackId}`
                                    })
                                    goIndex(item.url, trackId, item.keyword, item)
                                }}
                            >
                                <div className={'productMixedItemLeft'}>
                                    {
                                        item.businessLine === '0916' && goldDelayData ? (
                                            <p>
                                                {
                                                    item.productCode === 'Au(T+D)' && (<span>{goldDelayData}</span>)
                                                }
                                                {
                                                    item.productCode === 'mAu(T+D)' && (<span>{goldMiniData}</span>)
                                                }
                                                {
                                                    item.productCode === 'Ag(T+D)' && (<span>{silverData}</span>)
                                                }
                                            </p>
                                        ) : (
                                            <p>
                                                <span>{item.rate}</span>
                                                <i>%</i>
                                            </p>
                                        )
                                    }
                                    <p>
                                        {item.businessLine === '0916' ? item.introduce : item.rateName}
                                    </p>
                                </div>
                                <div className={'productMixedItemRight'}>
                                    <p>
                                        <span>{this.handleData(item.title)}</span>
                                        {item.productMark ? (<i>{item.productMark}</i>) : null}
                                    </p>
                                    <p>
                                        {item.businessLineName}{item.productTrait ? `${' | ' + item.productTrait}` : null}
                                    </p>
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }
}

export default ProductMixedByPlus
